import MypageSubscribeDetailsContainer from './MypageSubscribeDetailsContainer';
export default MypageSubscribeDetailsContainer;
